module.exports = __webpack_public_path__ + "static/media/4_Formoplast_MSS_20160622.ff2e1b9e.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2016/4_Formoplast_MSS_20160622.pdf
// module id = 167
// module chunks = 0